interface MapboxAddress {
  id: string;
  type: string;
  place_type: string[];
  relevance: number;
  properties: {
    accuracy: string;
    mapbox_id: string;
    address?: string;
  };
  text: string;
  place_name: string;
  center: [number, number];
  geometry: {
    type: string;
    coordinates: [number, number];
  };
  address: string;
  context: MapboxContext[];
}

interface MapboxContext {
  id: string;
  text: string;
  wikidata?: string;
  short_code?: string;
  mapbox_id?: string;
}

// If you have a response structure wrapping the features, you might also define:
export interface MapboxApiResponse {
  type: string;
  query: string[];
  features: MapboxAddress[];
}

export interface MapBoxAddressType {
  address: string;
  short_address: string;
  city: string;
  state: string;
  zip: string;
}

export type MapBoxAddressesType = Array<MapBoxAddressType> | [];

// TODO: Move to .env or config
const MAPBOX_KEY =
  'pk.eyJ1IjoidGotZXZlciIsImEiOiJjbHNrMGpmZXAycm5qMmxvMG9nNmoybDFmIn0.rOU9Xvgx-lil9KplueWevg';

export const fetchAutocompleteAddresses = async (
  query: string,
): Promise<MapBoxAddressesType> => {
  const baseUrl = 'https://api.mapbox.com/geocoding/v5/mapbox.places';
  const proximity = '-122.4194,37.7749'; // San Francisco coordinates for better accuracy
  const url = `${baseUrl}/${encodeURIComponent(
    query,
  )}.json?access_token=${MAPBOX_KEY}&country=US&proximity=${proximity}&types=address`;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Network response was not ok');
    const data: MapboxApiResponse = await response.json();

    const addresses = data.features.map((feature) => {
      let address = '',
        city = '',
        state = '',
        zip = '',
        short_address = '';

      address = feature.place_name;

      // Parsing address_1
      const placeNameParts = feature.place_name.split(', ');
      short_address = placeNameParts.length
        ? placeNameParts[0]
        : feature.place_name;

      // Parsing context for city, state, zip
      feature.context.forEach((contextItem) => {
        if (contextItem.id.startsWith('place')) {
          city = contextItem.text;
        } else if (contextItem.id.startsWith('region')) {
          state = contextItem.short_code?.replace('US-', '') || '';
        } else if (contextItem.id.startsWith('postcode')) {
          zip = contextItem.text;
        }
      });

      return { address, city, state, zip, short_address };
    });

    return addresses;
  } catch (error) {
    console.error('Error fetching addresses:', error);
    return [];
  }
};
